import { FullBridgeConverterDto } from '../dto/full-bridge-converter.dto'
import { FullBridgeConverter } from '../models/'
import { TFunction } from 'i18next'
import { format, isValid } from '@e3dc-react/shell/Libs/date'

const fromDtoToFullBridgeConverterModelTransformer = (dto: FullBridgeConverterDto[], t: TFunction): FullBridgeConverter[] =>
  dto.map(elem => {
    const buildDate = elem.buildDate?.[1]

    return {
      moduleName: elem.moduleName || '-',
      buildDate: buildDate && isValid(buildDate) ? format(new Date(buildDate), t('common.format.date-fns-date')) : '-',
      type: elem.DcdcType?.[1] || '-',
      deviceSerial: elem.DeviceSerial?.[1] || '-',
      boardVersion: elem.HWBoardVersion?.[1] || 0,
      cortexRevision: elem.HWCortexRev?.[1] || 0,
      moduleId: elem.HWModuleID?.[1] || 0,
      moduleVersion: elem.HWModuleVersion?.[1] || 0,
      swVersion: elem.swVersion?.[1] || 0.0,
    }
  })

export default fromDtoToFullBridgeConverterModelTransformer
